module.exports = __webpack_public_path__ + "static/media/wrong.66d98e53.svg";